export const COUPON_TARGETS = {
  VOD: "TARGET_VOD",
  VOD_SERIES: "TARGET_VOD_SERIES",
  TRAINER: "TARGET_TRAINER",
};

